export default __webpack_public_path__ + "static/screeny-130-gpz-i-scheda-tecnica-816a40c842be50f2454922315fb7f8f8.pdf";